<template>
	<v-navigation-drawer
		v-model="localValue"
		app
		dark
		:right="$i18n.locale === 'ar'"
		floating
		:permanent="$vuetify.breakpoint.mdAndUp"
		color="primary"
		width="215"
		:mini-variant="$vuetify.breakpoint.mdAndUp && !localValue"
	>
		<div class="d-flex my-4 ms-3">
			<!-- drawer button -->
			<v-btn
				icon
				@click="localValue = !localValue"
			>
				<v-icon>mdi-menu</v-icon>
			</v-btn>
			
			<!-- logo -->
			<router-link v-if="localValue" :to="{ name: 'home' }" class="ms-3">
				<v-img
					src="@/assets/logo.png"
					width="100%"
					max-width="100"
					transition="scale-transition"
				/>
			</router-link>
		</div>

		<v-list nav>
			<!-- logo -->
			<v-list-item
				v-if="!localValue"
				:ripple="false"
				class="px-0"
				@click="$route.name !== 'home' ? $router.push({ name: 'home' }) : null"
			>
				<v-list-item-avatar tile class="ma-0">
					<v-img
						src="@/assets/logo.png"
						:max-width="32"
						contain
						transition="scale-transition"
					/>
				</v-list-item-avatar>
			</v-list-item>

			<!-- pages -->
			<v-list-item
				v-for="(page, index) in pages"
				:key="index"
				:to="{ name: page.target }"
				exact-path
			>
				<v-list-item-icon><v-icon>{{page.icon}}</v-icon></v-list-item-icon>
				<v-list-item-title>{{page.title}}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
export default {
	name: 'NavigationDrawer',
	props: {
		value: { type: Boolean }
	},

	computed: {
		pages() {
			return [
				{
					title: this.$t('routes.company-info'),
					target: 'company-info',
					icon: 'mdi-card-account-details',
				},
				{
					title: this.$t('routes.passengers-data'),
					target: 'passengers-data',
					icon: 'mdi-account-group',
				},
				{
					title: this.$t('routes.vehicles-data'),
					target: 'vehicles-data',
					icon: 'mdi-bus-multiple',
				},
				{
					title: this.$t('routes.quick-messages'),
					target: 'quick-messages',
					icon: 'mdi-message-text-fast',
				},
				{
					title: this.$t('routes.map-management'),
					target: 'map-management',
					icon: 'mdi-map-legend',
				}
			]
		},

		localValue: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit('input', newVal);
			}
		}
	}
};
</script>

<style>
</style>